<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 0.875C3.61758 0.875 0.875 3.61758 0.875 7C0.875 10.3824 3.61758 13.125 7 13.125C10.3824 13.125 13.125 10.3824 13.125 7C13.125 3.61758 10.3824 0.875 7 0.875ZM9.41309 8.88262L9.02207 9.41582C9.01357 9.42743 9.00285 9.43725 8.99054 9.4447C8.97823 9.45216 8.96457 9.45711 8.95034 9.45927C8.93611 9.46143 8.92159 9.46076 8.90763 9.45729C8.89366 9.45382 8.88051 9.44763 8.86895 9.43906L6.60762 7.79023C6.59353 7.78012 6.58208 7.76676 6.57423 7.7513C6.56638 7.73583 6.56235 7.71871 6.5625 7.70137V3.9375C6.5625 3.87734 6.61172 3.82812 6.67188 3.82812H7.32949C7.38965 3.82812 7.43887 3.87734 7.43887 3.9375V7.32129L9.38848 8.73086C9.4377 8.76504 9.44863 8.8334 9.41309 8.88262Z"
      fill="currentColor"
    />
  </svg>
</template>
